import "../types/index.js";

import { ApiService } from "./ApiService.js";

export class MessageApiService extends ApiService {
  /** @returns {Promise<number>} count */
  async getUnreadCount() {
    const response = await this.get("/api/messages/count");
    if (response.ok) {
      const messages = await response.json();
      return messages["unread"];
    } else {
      throw this.buildApiError(response, "Error getting unread messages count");
    }
  }
}
